import { TApplicationState } from '../../types/redux';

export function getGenplanSelector(state: TApplicationState) {
  return state.newbuilding.genplan;
}
